import React from "react";

import { Button, Space } from "@masterteam/mt-design-react";

import Modal from "../Modal";
import { ReactComponent as LockIcon } from "../../assets/images/lock.svg";
import { ReactComponent as UnlockIcon } from "../../assets/images/unlock.svg";

import "./style.scss";

const LockActionModal = ({
  ButtonStatus,
  title,
  closeModal,
  handleAction,
  isOpen,
  isLocked
}) => {
  return (
    <Modal isOpen={isOpen}>
      <Space
        direction="vertical"
        size="large"
        align="center"
        className="lock-box-container"
      >
        <Space
          direction="vertical"
          size="large"
          justify="center"
          align="center"
        >
          <Space direction="vertical" align="center">
            {isLocked ? (
              <UnlockIcon
                className="tab-icon"
                style={{
                  fill: "var(--primary-color)",
                  width: 50,
                  height: 50
                }}
              />
            ) : (
              <LockIcon
                className="tab-icon"
                style={{
                  fill: "var(--primary-color)",
                  width: 50,
                  height: 50
                }}
              />
            )}
            <span style={{ color: "#5d5d5d" }} className="title">
              {isLocked ? `Unlock ${title} ?` : `Lock ${title} ?`}
            </span>
          </Space>
          <span className="modal-delete-body text-normal">
            Are you sure you want to {isLocked ? "unlock" : "lock"} this KPI{" "}
            {isLocked ? "and open it for update" : ""} ?
          </span>
        </Space>
        <Space size="medium">
          <Button type="button" onClick={closeModal} variant="dark">
            Cancel
          </Button>
          <Button
            type="button"
            onClick={handleAction}
            variant="primary"
            loading={ButtonStatus}
          >
            {isLocked ? "Unlock !" : "Lock !"}
          </Button>
        </Space>
      </Space>
    </Modal>
  );
};

export default LockActionModal;
